import { FormSelectProps } from '../../types/Forms/FormSelect';

export const FormSelect = (props: FormSelectProps) => {
  return (
    <div className="my-2 mr-4 flex flex-col text-xl font-bold">
      <label htmlFor="location">{props.label}</label>
      <select
        id={props.id}
        name={props.name}
        value={props.value}
        required={props.required}
        onBlur={props.onBlur}
        onChange={props.onChange}
        className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-lg text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
      >
        {props.options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.name}
          </option>
        ))}
      </select>
    </div>
  );
};
